import { DevBoxHyperVProvisioningState, DevBoxHyperVStatus } from '../constants/add-ons';
import { DevBoxProvisioningState } from '../constants/dev-box';
import { DevBoxHyperVAddOn } from '../models/add-ons';
import { DevBox } from '../models/dev-box';
import { DevBoxState } from '../redux/store/dev-box-state';

// Still returning DevBoxState since if an add-on is present - its state should take precedence over host devbox state
export const getDevBoxHyperVAddOnState = (addOn: DevBoxHyperVAddOn, devBox: DevBox): DevBoxState => {
    const { provisioningState } = devBox;

    // For now, deleting hyper-v is equivalent to deleting the devbox, so considering dev box provisioning state, not add-on state.
    if (provisioningState === DevBoxProvisioningState.Deleting) {
        return DevBoxState.Deleting;
    }

    const devBoxHyperVProvisioningState = addOn.provisioningState;
    const devBoxAddOnHyperVStatus = addOn.devBoxHyperVStatus;

    // Check provisioning state first, as it takes precedence over the action state.
    if (!!devBoxHyperVProvisioningState) {
        switch (devBoxHyperVProvisioningState) {
            case DevBoxHyperVProvisioningState.Failed:
                return DevBoxState.Failed;
            case DevBoxHyperVProvisioningState.Creating:
                return DevBoxState.Creating;
        }
    }

    // Check action state next.
    if (!!devBoxAddOnHyperVStatus) {
        switch (devBoxAddOnHyperVStatus) {
            case DevBoxHyperVStatus.Stopped:
                return DevBoxState.Stopped;
            case DevBoxHyperVStatus.Starting:
                return DevBoxState.Starting;
            case DevBoxHyperVStatus.Running:
                return DevBoxState.Running;
            case DevBoxHyperVStatus.Stopping:
                return DevBoxState.Stopping;
        }
    }

    // If we reach here, assume devbox is in a failed state.
    return DevBoxState.Failed;
};
